// extracted by mini-css-extract-plugin
module.exports = {"content":"termly-embed_content__4jJe2","card":"termly-embed_card__RBxOk","cardHeader":"termly-embed_cardHeader__5tC_C"};